import { Container } from "@fluidattacks/design";
import type { FC } from "react";
import { StrictMode } from "react";

import { AddButton } from "./add-button";
import { AttackedButton } from "./attacked-button";

import { ExportButton } from "components/export-multiple-csv/export-button";
import type { CsvReportFiltersInput } from "gql/graphql";
import { ReportType } from "gql/graphql";

interface IActionButtonsProps {
  areInputsSelected: boolean;
  isAdding: boolean;
  isFiltered?: boolean;
  isMarkingAsAttacked: boolean;
  isInternal: boolean;
  onAdd: () => void;
  onMarkAsAttacked: () => void;
  filters?: CsvReportFiltersInput;
}

const ActionButtons: FC<IActionButtonsProps> = ({
  areInputsSelected,
  isAdding,
  isFiltered = false,
  isInternal,
  isMarkingAsAttacked,
  onAdd,
  onMarkAsAttacked,
  filters,
}): JSX.Element | null => {
  return (
    <Container display={"flex"} gap={0.5} justify={"flex-end"} width={"100%"}>
      {isInternal ? (
        <StrictMode>
          <AddButton isDisabled={isAdding} onAdd={onAdd} />
          <AttackedButton
            isDisabled={isMarkingAsAttacked || !areInputsSelected}
            onAttacked={onMarkAsAttacked}
          />
        </StrictMode>
      ) : null}
      <ExportButton
        filters={filters}
        isFiltered={isFiltered}
        reportType={ReportType.ToeInputs}
      />
    </Container>
  );
};

export { ActionButtons };
